import React from "react";
import { Button } from "./ui/button";

export const HeroSection = () => {
  const scrollToContact = () => {
    document.getElementById("contact")?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section className="min-h-screen flex items-center justify-center px-6 py-20 relative overflow-hidden">
      {/* Background Image */}
      <div
        className="absolute inset-0 z-0"
        style={{
          backgroundImage: "url(/assets/home-hero-background.png)",
          backgroundSize: "cover",
          backgroundPosition: "center",
          opacity: 0.3,
        }}
      />

      <div className="max-w-7xl mx-auto w-full relative z-10">
        <div className="grid md:grid-cols-2 gap-12 items-center">
          {/* Left Side - Text Content */}
          <div className="space-y-6 text-left">
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-gray-800 leading-tight">
              Rasika Godbole
            </h1>
            <p className="text-xl md:text-2xl text-gray-600 font-medium">
              (MSc Clinical Psychology)
            </p>
            <p className="text-lg md:text-xl text-gray-700 leading-relaxed">
              Talk to someone who can truly listen and be there for you. I am a
              trained psychotherapist, and I'd love to be a part of your
              journey.
            </p>
            <Button
              onClick={scrollToContact}
              className="bg-black hover:bg-gray-800 text-white px-8 py-6 text-lg rounded-full transition-all duration-300 transform hover:scale-105"
            >
              Try therapy
            </Button>
          </div>

          {/* Right Side - Profile Image */}
          <div className="flex justify-center md:justify-end">
            <div className="relative">
              <div className="absolute inset-0 bg-blue-200 rounded-full blur-3xl opacity-30 transform scale-110"></div>
              <img
                src="/assets/rasika-profile-picture.jpg"
                alt="Rasika Godbole"
                className="relative rounded-full w-56 h-56 md:w-72 md:h-72 lg:w-80 lg:h-80 object-cover shadow-2xl border-8 border-white"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
